module.exports = __webpack_public_path__ + "static/media/teste-botao-filtro.8abfb824.svg";